import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const ButtonContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
}));

type ButtonContentProps = {
  isFirst: boolean;
  isLast: Boolean;
  isActive: boolean;
};
export const ButtonContent = styled("div")(({ isFirst, isLast, isActive }: ButtonContentProps) => ({
  padding: "10px 12px",
  minWidth: "104px",
  maxHeight: "40px",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: colors.brandBlue50,
  borderTopLeftRadius: isFirst ? "8px" : "0px",
  borderBottomLeftRadius: isFirst ? "8px" : "0px",
  borderTopRightRadius: isLast ? "8px" : "0px",
  borderBottomRightRadius: isLast ? "8px" : "0px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  columnGap: "8px",
  cursor: "pointer",
  backgroundColor: isActive ? colors.brandBlue50 : colors.white,
  "& span": {
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0.1px",
    color: isActive ? colors.brandBlue500 : colors.gray800,
  },
  "& svg": {
    position: "relative",
    top: "2px",
  },
}));
